module.exports = __webpack_public_path__ + "static/media/mapNode3.1dd7bb6b.png";